import React, { useEffect, useState } from "react";
import { Box, Typography, Stack, Button, useTheme, TableRow, TableHead, TableCell, TableBody } from "@mui/material";
import BackButton from "../../../components/BackButton";
import LabelTxtFieldInfo from "../../../components/LabelTxtFieldInfo";
import BgBoxOld from "../../../components/BgBoxOld";
import { useAuthContext } from "../../../context/AuthContext";
import { customAlert, notify } from "../../../components/notify";
import route from "../../../utils/Routes";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import QueryKey from "../../../utils/QueryKey";
import { getBalance, isNotEmpty } from "../../../utils/format";
import { createDoServ, getSinglePoStoreServ } from "../../../services/po-service";
import StyledTableContainer from "../../../components/StyledTableContainer";
import TableTxtField from "../AddProdToCompCatalog2/TableTxtField";
import AttachFileUpload from "../../../components/AttachFileUpload";
import constants from "../../../utils/Constants";
import { getSingleComServ } from "../../../services/com-service";
import AddrPopupMdl from "./AddrPopupMdl";

const columns = [
  { id: "serial", label: "S.No", align: "left", minWidth: 30 },
  { id: "prodName", label: "Product", align: "left", minWidth: 300 },
  { id: "amtcProdIdStrg", label: "AMTC Product ID", align: "left", minWidth: 150 },
  { id: "comProdIdStrg", label: "Material Code", align: "left", minWidth: 150 },
  { id: "orderedQty", label: "Ordered Qty", align: "left", minWidth: 50 },
  { id: "balQty", label: "Remaining Qty", align: "left", minWidth: 50 },
  { id: "deliveredQty", label: "Delivered Qty", align: "left", minWidth: 50 },
  { id: "prodAttachArr", label: "Attachments", align: "left", minWidth: 500 },
];

function CreateDoPage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { poIdStrg } = location.state || {};
  const { setLoadingScreen, setNavComValue, ctxtUser } = useAuthContext();

  const [errors, setErrors] = useState({});
  // const [attchs, setAttchs] = useState([]);
  const [selection, setSelection] = useState({ addr: "" });

  const { isLoading, isError, error, data: poData } = useQuery([QueryKey.poInfo, poIdStrg],
    () => getSinglePoStoreServ(poIdStrg),
    {
      enabled: isNotEmpty(poIdStrg),
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    });
  const { isLoading: isComLoading, isError: isComErr, error: comErr, data: comData } = useQuery([QueryKey.singleCom, poData?.comId],
    () => getSingleComServ(poData?.comId),
    {
      enabled: isNotEmpty(poData?.comId),
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      retry: false,
    })
  const [rows, setRows] = useState([
    {
      id: 1,
      prodName: "",
      amtcProdIdStrg: "",
      comProdIdStrg: "",
      orderedQty: "",
      balQty: "",
      deliveredQty: "",
      prodAttachArr: []
    }
  ]);
  const [addrMdl, setAddrMdl] = useState(false);
  const handleAddrMdlClose = () => setAddrMdl(false);
  const handleAddrMdlOpen = () => setAddrMdl(true);

  const compactTextFieldStyles = {
    '& .MuiInputBase-root': {
      padding: '0 !important',
      height: '100%',
    },
    '& .MuiInputBase-input': {
      padding: '4px 6px !important',
      fontSize: '13px'
    }
  };



  useEffect(() => {
    if (!poData)
      return
    if (!poData?.prods)
      return
    else {
      setValuesToRow(poData?.prods);
      setNavComValue({ comId: poData?.comId });
      return () => setNavComValue({ comId: "" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poData]);

  // function handleFileRemove(index) {
  // const updatedImages = attchs.filter((_, i) => i !== index);
  // setAttchs(updatedImages);
  // };

  // function handleOnFileUpload(uploadedFiles) {
  // setAttchs(prev => [...prev, ...uploadedFiles])
  // }

  function handleOnFileUpload(index, uploadedFiles) {
    setRows(prevRows => {
      const newRows = [...prevRows];
      const existingFiles = newRows[index]?.prodAttachArr || [];
      newRows[index].prodAttachArr = [...existingFiles, ...uploadedFiles];
      return newRows;
    });
  }

  function handleFileRemove(rowIndex, fileIndex) {
    setRows(prevRows => {
      const newRows = [...prevRows];
      const updatedFiles = [...newRows[rowIndex].prodAttachArr];
      updatedFiles.splice(fileIndex, 1);
      newRows[rowIndex].prodAttachArr = updatedFiles;
      return newRows;
    });
  }


  function setValuesToRow(data) {
    const arr = data.map((i, index) => ({
      id: i?.id,
      prodName: i?.prodName,
      amtcProdIdStrg: i?.amtcProdIdStrg,
      comProdIdStrg: i?.comProdIdStrg,
      orderedQty: i?.orderedQty,
      balQty: getBalance(i?.orderedQty, i?.poDeliveredQty),
      deliveredQty: "",
      prodAttachArr: []
    }))
    setRows(arr);
  }


  useEffect(() => {
    setLoadingScreen(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  useEffect(() => {
    setLoadingScreen(isComLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isComLoading]);


  useEffect(() => {
    if (!poIdStrg)
      navigate("/", { replace: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poIdStrg])


  const handleInputChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };



  async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
    if (!validate(inputObject))
      return;

    setLoadingScreen(true);
    try {

      const payload = {
        poIdStrg,
        deliveredAt: isNotEmpty(inputObject.deliveredAt) ? inputObject.deliveredAt : null,
        dispatchLocation: selection.addr,
        actDoNum: inputObject.actDoNum,
        doDesc: inputObject.doDesc,
        productArr: rows.map((row) => ({
          poProdId: row.id,
          deliveredQty: Number(row.deliveredQty),
          prodAttachArr: [...row.prodAttachArr]
        })),
      };
     
      const { message } = await createDoServ(payload);
      notify("success", message);
      if (ctxtUser?.userType === constants.store)
        navigate(`${route.aStorePoInfo}/?poId=${poIdStrg}`, { replace: true })
      else
        navigate(`${route.aPoInfo}/?poId=${poIdStrg}`, { replace: true })
    } catch (error) {
      console.log(error)
      customAlert(error)
    }
    setLoadingScreen(false);
  };

  async function handleCancel() {
    if (ctxtUser?.userType === constants.store)
      navigate(`${route.aStorePoInfo}/?poId=${poIdStrg}`, { replace: true })
    else
      navigate(`${route.aPoInfo}/?poId=${poIdStrg}`, { replace: true })
  }



  const validate = (values) => {
    const newErrors = {};
    if (!values.actDoNum)
      newErrors.actDoNum = "DO Number is required!";
    rows.forEach((row, index) => {
      Object.keys(row).forEach((key) => {
        // if (!row[key] && key !== "serial") {
        //     newErrors[`${index}-${key}`] = "Required";
        // }
        // if (!row[key] && key === "deliveredQty") {
        //   newErrors[`${index}-${key}`] = "Required";
        // }

      });
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  async function handleMdlSave(e) {
    console.log(e)
    setAddrMdl(false)
    setSelection((i) => { return { ...i, addr: e.addr } });
  }

  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }

  if (isComErr) {
    customAlert(comErr);
    return <h2>Something went wrong</h2>
  }

  return (
    <form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%" }}>
      <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5}>
        <BackButton width={"20%"} />
        <Stack width={"60%"} alignItems={"center"}>
          <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Create Delivery Order </Typography>
        </Stack>
        <Stack width={"20%"} />
        <Box />
      </Stack>
      <BgBoxOld height={"93%"} py={0.5} px={1}>
        {poData && <Stack width={"100%"} height={"100%"} position={"relative"}>
          {/* <Stack width={"100%"} direction={"row"} justifyContent={"space-between"} mt={1} mb={1} alignItems={"center"} px={0.5}>
            <Typography fontSize={15} fontWeight="medium">Product List</Typography>
          </Stack> */}
          <Stack height={"100%"} width={"100%"} alignItems={"center"}>
            <Stack direction={"row"} alignItems={"center"} gap={2} mb={1} width={"100%"} px={3} justifyContent={"space-between"}>
              <Stack gap={1} width={"20%"} >
                <LabelTxtFieldInfo name="poIdStrg" defaultValue={poData?.poIdStrg} readOnly={true} title="Order Request ID" bgColor={"rgba(162, 214, 249, 0.18)"} width={250} height={30} borderRadius={1} rows={1} />
                <LabelTxtFieldInfo name="actProjIdStrg" defaultValue={poData?.actProjIdStrg} readOnly={true} title="PO Number" bgColor={"rgba(162, 214, 249, 0.18)"} width={250} height={30} borderRadius={1} rows={1} />
              </Stack>
              <Stack gap={1} width={"20%"}>
                <LabelTxtFieldInfo name="actDoNum" errMsg={errors.actDoNum} title="DO Number*" width={250} height={30} borderRadius={1} rows={1} />
                <LabelTxtFieldInfo name="deliveredAt" type='date' errMsg={errors.deliveredAt} title="Delivered At" width={250} height={30} borderRadius={1} rows={1} />
              </Stack>
              <Stack width={"25%"}>
                {/* <StyleCustomDropDown width={250} height={100} borderRadius={1} rows={4} handleDDChange={handleDDChange} errMsg={errors.comId} ddArr={comData?.addrArr || []} name={"dispatchLocation"} title={"Dispatch Location"} /> */}
                <Stack onClick={handleAddrMdlOpen}>
                  {selection && <LabelTxtFieldInfo defaultValue={selection.addr} readOnly={true} name="addr" title="Delivery Location" width={"100%"} borderRadius={1} rows={4} multiline={true} height={100} />}
                </Stack>
              </Stack>
              <Stack width={"25%"}>
                <LabelTxtFieldInfo name="doDesc" title="Description" width={"100%"} borderRadius={1} rows={4} multiline={true} height={100} />
              </Stack>
              {/* <Stack width={"62%"}> */}
              {/* <AttachFileUpload title={"Attachments"} height={100} width={"100%"} filesArr={attchs} onUpload={handleOnFileUpload} onRemove={handleFileRemove} /> */}
              {/* </Stack> */}
            </Stack>
            <StyledTableContainer height={"75%"} isStickyHeader={true} width={"100%"}>
              <TableHead>
                <TableRow >
                  {columns.map((column) => (
                    <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((i, index) => {
                  return (
                    <TableRow hover tabIndex={-1} key={i?.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 }, height: 50, cursor: 'pointer' }} >
                      {columns.map((column) => {
                        const value = i[column.id];
                        switch (column.id) {
                          case "prodAttachArr":
                            return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13, px: 1.2 }}>
                              <AttachFileUpload 
                                inputId={`file-upload-${index}`}
                                btnHeight={35} btnIcSize={25} maxHeight={200} width={"100%"} filesArr={value}
                                fileWidth={163} needFileIc={false}
                                onUpload={(files) => handleOnFileUpload(index, files)}
                                onRemove={(fileIndex) => handleFileRemove(index, fileIndex)} />
                            </TableCell>
                          case "deliveredQty":
                            return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13, px: 1.2 }}>
                              <TableTxtField type={"number"} value={value} errMsg={errors[`${index}-${column.id}`]}
                                onChange={(e) => handleInputChange(index, column.id, e.target.value)} />
                            </TableCell>
                          case "balQty":
                          case "orderedQty":
                          case "prodName":
                          case "amtcProdIdStrg":
                          case "comProdIdStrg":
                            return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13, px: 1.2 }}>
                              <TableTxtField value={value ?? ""} errMsg={errors[`${index}-${column.id}`]}
                                readOnly={true} bgColor={"rgba(162, 214, 249, 0.18)"} sx={compactTextFieldStyles} />
                            </TableCell>
                          case "serial":
                            return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13, px: 1.2 }}>
                              <TableTxtField value={index + 1} errMsg={errors[`${index}-${column.id}`]}
                                readOnly={true} bgColor={"rgba(162, 214, 249, 0.18)"} />
                            </TableCell>
                          default:
                            return (
                              <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13, px: 1.2 }}>
                                {(value === null || value === "" || value === "null") ? "NA" : value}
                              </TableCell>
                            );
                        }
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </StyledTableContainer>
          </Stack>

          <Box sx={{ position: "absolute", bottom: 5, right: 0 }}>
            <Button variant="outlined" onClick={handleCancel} sx={{
              fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
              color: theme.palette.custom.btn, mr: 2,
            }}>CANCEL</Button>
            <Button variant="contained" type="submit"
              sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", }}>CREATE</Button>
          </Box>
        </Stack>}
      </BgBoxOld>
      {comData && <AddrPopupMdl modalOpen={addrMdl} handleModalClose={handleAddrMdlClose} handleMdlSave={handleMdlSave} addrArr={comData?.addrArr || []} />}
    </form>
  );
};

export default CreateDoPage;